module.exports = __webpack_public_path__ + "static/social-media-management-2d8f060538bbea3882583f22d1fea3b2.png";